import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from './Icon';

/**
 * <Alert tone="danger" onDismiss={fn}>Message</Alert>
 * tone — danger | success | warning | info
 */
const TONES = ['danger', 'success', 'warning', 'info'];
const ICON  = {
  danger:  'alertCircle',
  success: 'success',
  warning: 'warning',
  info:    'info',
};

export default function Alert({
  tone = 'info',
  onDismiss,
  children,
  icon = true,
  title,
  role,
  className = '',
  style,
  ...rest
}) {
  const { t: tt } = useTranslation();
  const t = TONES.includes(tone) ? tone : 'info';

  return (
    <div
      role={role || (t === 'danger' || t === 'warning' ? 'alert' : 'status')}
      aria-live={t === 'danger' ? 'assertive' : 'polite'}
      className={`alert alert-${t} d-flex align-items-start gap-2 ${className}`.trim()}
      style={style}
      {...rest}
    >
      {icon && (
        <Icon
          name={ICON[t]}
          size="sm"
          style={{ flexShrink: 0, marginTop: title ? 1 : 0 }}
        />
      )}
      <div style={{ flex: 1, minWidth: 0 }}>
        {title && (
          <div style={{ fontWeight: 'var(--fw-semi)', marginBottom: 2, fontSize: 'var(--fs-sm)' }}>
            {title}
          </div>
        )}
        <span style={{ fontSize: 'var(--fs-sm)', lineHeight: 'var(--lh-base)' }}>
          {children}
        </span>
      </div>
      {onDismiss && (
        <button
          type="button"
          onClick={onDismiss}
          aria-label={tt('common.a11y.dismiss')}
          style={{
            background: 'transparent',
            border: 'none',
            color: 'inherit',
            cursor: 'pointer',
            opacity: 0.55,
            padding: 2,
            display: 'flex',
            alignItems: 'center',
            borderRadius: 'var(--radius-sm)',
            flexShrink: 0,
            alignSelf: 'flex-start',
            transition: 'opacity var(--dur-fast)',
          }}
          onMouseEnter={e => e.currentTarget.style.opacity = '1'}
          onMouseLeave={e => e.currentTarget.style.opacity = '0.55'}
        >
          <Icon name="close" size="sm" />
        </button>
      )}
    </div>
  );
}
